module.exports = __webpack_public_path__ + "static/media/research-and-innovation.efdb9929.png";